import { useEffect, useState } from 'react';
import { InterfaceInvestment } from '../../interfaces/Interfaces';
import ListApi from '../../api/genericApis/List.api';
import { Link } from 'react-router-dom';
import { EditInvestmentRoute } from '../../consts/consts';
import { ModuleType } from '../../api/modules.types';
import ServiceCard from '../shared/card/ServiceCard';
import ServiceCardSkeleton from '../completedProjects/ServiceCardSkeleton';
import FilterAndSearch from '../shared/FilterAndSearch';

export default function InvestmentTable() {
  const [list, setList] = useState<InterfaceInvestment[]>([]);
  const [filteredList, setFilteredList] = useState<InterfaceInvestment[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [activeFilter, setActiveFilter] = useState<
    'all' | 'active' | 'inactive'
  >('all');
  const [searchQuery, setSearchQuery] = useState<string>('');

  const getList = async () => {
    setLoading(true);
    await ListApi({ moduleType: ModuleType.investment })
      .then((response) => {
        setList(response.data);
        setFilteredList(response.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    let filtered = list;
    if (activeFilter !== 'all') {
      filtered = filtered.filter(
        (item) =>
          (activeFilter === 'active' && item.investmentStatus === 1) ||
          (activeFilter === 'inactive' && item.investmentStatus === 0),
      );
    }

    if (searchQuery) {
      filtered = filtered.filter(
        (item) =>
          item.investmentTitleEn
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          item.investmentCityEn
            .toLowerCase()
            .includes(searchQuery.toLowerCase()),
      );
    }

    setFilteredList(filtered);
  }, [activeFilter, searchQuery, list]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h3>Investment Opportunities List</h3>

        <Link to="/investments/add-investment" className="btn btn-primary">
          Add Investment
        </Link>
      </div>

      {/* Filter and Search Inputs */}
      <FilterAndSearch
        activeFilter={activeFilter}
        searchQuery={searchQuery}
        onFilterChange={setActiveFilter}
        onSearchChange={setSearchQuery}
      />

      <div className="row">
        {loading && <ServiceCardSkeleton />}
        {!loading && filteredList && filteredList.length > 0 ? (
          filteredList.map((item, index) => (
            <ServiceCard
              key={index}
              title={item.investmentTitleEn}
              city={item.investmentCityEn}
              imageUrl={item.investmentImageUrl}
              status={item.investmentStatus === 1}
              editRoute={EditInvestmentRoute(item.investmentId)}
              moduleType={ModuleType.investment}
              id={item.investmentId}
              getList={getList}
            />
          ))
        ) : (
          <p>No Investments found</p>
        )}
      </div>
    </div>
  );
}
